import { render, staticRenderFns } from "./subproject.vue?vue&type=template&id=270c49b2&scoped=true&"
import script from "./subproject.vue?vue&type=script&lang=js&"
export * from "./subproject.vue?vue&type=script&lang=js&"
import style0 from "./subproject.vue?vue&type=style&index=0&id=270c49b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c49b2",
  null
  
)

export default component.exports